export const THEMES = {
  LIGHT: 'LIGHT',
  DARK: 'DARK',
  NATURE: 'NATURE',
};

export const LOCAL_STORAGE_KEYS = {
  AccessToken: 'accessToken',
  SelectedVendor: 'selectedVendor',
  Settings: 'settings',
  UserName: 'userName',
  Password: 'password',
};
